// extracted by mini-css-extract-plugin
module.exports = {"fixedWrapper":"OurReviewModalContent_fixedWrapper__rnWpY","modalWrapper":"OurReviewModalContent_modalWrapper__sDk46","contentWrapper":"OurReviewModalContent_contentWrapper__cbgv0"};